import { TelemetryScrubberInput } from "rollbar";

// see Rollbar docs for more info on telemetry: https://docs.rollbar.com/docs/rollbarjs-telemetry
export function rollbarTelemetryScrubber(node: TelemetryScrubberInput) {
	return node?.tagName === "input";
}
